export const getImgAlt = (obj, fallback = '') => {
    if (!obj) return fallback;
    return obj.image_alt || obj.alt || obj.title || fallback;
};
